import ApiService from 'api/ApiService';
import {getTransactionErrorMessages} from 'common/messageUtils';
import {DialogTypes} from 'common/names';
import {combineYupErrors} from 'common/yup/combineYupErrors';
import {pageSelectors} from 'features/layout/CommonPage/redux';
import {layoutActions} from 'features/layout/redux';
import {pushSuccessToast} from 'features/notifications/redux/actions';
import i18n from 'i18n';
import {isEmpty} from 'lodash';
import {call, put, select} from 'redux-saga/effects';
import {asyncSagaConstructor, SagaError} from 'redux/common';
import {transactionSynchronizationGetters} from 'redux/transactions/transactionSynchronizationGetters';
import {ITransactionErrorResponse} from 'types/diplomat/ErrorResponse';
import {ISynchronization} from 'types/diplomat/transaction/Synchronization';
import {ITransaction} from 'types/diplomat/transaction/Transaction';
import {validateTransaction} from 'types/diplomat/transaction/validation';

export function* validate(act: {type: string; payload: {data: ITransaction | ISynchronization}}) {
   try {
      const isSynchronization = (yield select(pageSelectors.isSynchronization)) as boolean;
      let {apiValidate, reduxValidateType, label} = isSynchronization
         ? transactionSynchronizationGetters.Synchronization
         : transactionSynchronizationGetters.Transaction;

      const data = act.payload.data;
      // TODO validate by src\types\diplomat\transaction\validation.ts > validateTransaction

      if (!isSynchronization) {
         const errors = validateTransaction(data as ITransaction);
         if (!isEmpty(errors)) {
            const errorList = [] as string[];
            yield call(combineYupErrors, errorList, errors);
            throw {message: errorList.join('\n')};
         }
      }

      const request = asyncSagaConstructor(apiValidate, reduxValidateType, {
         data,
         getMethod: ApiService.postSecureJson,
         hideErrorToast: true,
      });

      yield call(request);
      yield put(pushSuccessToast(i18n.t('{{label}} {{name}} is Valid', {name: data.name, label})));
   } catch (e) {
      console.error(e);

      const messages = (yield call(
         getTransactionErrorMessages,
         (e as ITransactionErrorResponse).errorBody,
         (e as ITransactionErrorResponse).message
      )) as React.ReactNode;

      yield put(
         layoutActions.openSubDialog({
            id: DialogTypes.AlertDialog.id,
            title: i18n.t('Validation'),
            content: messages,
            maxWidth: 'md',
         })
      );
      // yield put(pushErrorToast());
   }
}
